import type { Variants } from 'framer-motion'

export const slideUp: Variants = {
  hidden: { y: '100%', opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
    transition: {
      duration: 0.5,
      ease: [0.25, 1.5, 0.5, 1],
    },
  },
}
